import { DataModel } from "../../../../lib/data/model/DataModel.js";

export class UnitWeightOfSolidsGamaSCalculationMethodModel extends DataModel {

    static _instance = null;

    static getInstance(authManager) {

        if (UnitWeightOfSolidsGamaSCalculationMethodModel._instance == null) UnitWeightOfSolidsGamaSCalculationMethodModel._instance = new UnitWeightOfSolidsGamaSCalculationMethodModel(authManager);
        return UnitWeightOfSolidsGamaSCalculationMethodModel._instance;

    }

    constructor (authManager) {

        super(authManager, 'geo-sections/unit-weight-of-solids-gama-s-calculation-methods', 'geo-sections/unit-weight-of-solids-gama-s-calculation-methods/codelist');

        this.entityName = 'geo-sections.UnitWeightOfSolidsGamaSCalculationMethod';
        this.privileges = {
            create: [["#admin"]],
            read: [["adminGeotechData"],["manageGeotechData"],["editGeotechData"],["readGeotechData"]],
            update: [["#admin"]],
            delete: [["#admin"]],
        };

        this.label = 'Unit Weight Of Solids Gama S Calc Method';
        this.setLabel = 'Unit Weight Of Solids Gama S Calc Methods';

        this.browser = {
            name: 'default-geo-sections-unitweightofsolidsgamascalculationmethod-browser',
            moduleName: 'default-geo-sections-unitweightofsolidsgamascalculationmethod-browser',
            moduleTitle: 'Unit Weight Of Solids Gama S Calc Methods',
            moduleStateSlotName: 'default-geo-sections-unitweightofsolidsgamascalculationmethod-browser',
        };

        this.editor = {
            name: 'default-geo-sections-unitweightofsolidsgamascalculationmethod-editor',
            moduleName: 'default-geo-sections-unitweightofsolidsgamascalculationmethod-editor',
            moduleTitle: 'Unit Weight Of Solids Gama S Calc Method',
            moduleStateSlotName: 'default-geo-sections-unitweightofsolidsgamascalculationmethod-editor',
        };

        this.fieldDefs = [
            {
                name: 'id',
                type: 'int',
                persistent: true,
                label: '#ID',
                primaryKey: true,
                required: true,
                readOnly: true,
            },
            {
                name: 'code',
                type: 'string',
                persistent: true,
                label: 'Code',
                required: true,
                readOnly: true,
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'name',
                type: 'string',
                persistent: true,
                label: 'Name',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'description',
                type: 'text',
                persistent: true,
                label: 'Description',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'notes',
                type: 'text',
                persistent: true,
                label: 'Notes',
                inEditor: true,
                filterable: true,
            },
            {
                name: 'isDisabled',
                type: 'bool',
                persistent: true,
                label: 'Is Disabled',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayPosition',
                type: 'int',
                persistent: true,
                label: 'Display Position',
                inEditor: true,
                inBrowser: true,
                filterable: true,
                orderable: true,
            },
            {
                name: 'displayLabel',
                type: 'string',
                persistent: false,
                label: 'Display Label',
                readOnly: true,
            },
            {
                name: 'displayDisabled',
                type: 'bool',
                persistent: false,
                label: 'Display Disabled',
                readOnly: true,
            },
        ];

    }

}
